import { render, staticRenderFns } from "./DetailOptions.vue?vue&type=template&id=14a8c756&"
import script from "./DetailOptions.vue?vue&type=script&lang=js&"
export * from "./DetailOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports